import React from 'react';
import { Redirect } from 'react-router';
import { Col, Container, Row } from 'react-bootstrap';

import { CustomerProvider } from '../../providers/CustomerProvider';
import { DocumentProvider } from '../../providers/DocumentProvider';

import { CustomerItem, DocumentItem } from '../../providers/Models';

import { CustomAlert, ICustomAlertProps } from '../Common/CustomAlert';
import { CustomerDetail } from '../Customer/CustomerDetail';
import { DocumentList } from '../Document/DocumentList';

import * as Constants from '../Constants';

interface Props { }

interface State {
  username: string,
  sessionKey: string,
  isSessionValid: boolean,
  customer: CustomerItem,
  documents: DocumentItem[],
  alertProps: ICustomAlertProps | null | undefined,
}

export class CustomerDocuments extends React.Component<Props, State> {

  customerProvider: CustomerProvider;
  documentProvider: DocumentProvider;

  constructor(props: Props) {
    super(props);
    this.customerProvider = new CustomerProvider();
    this.documentProvider = new DocumentProvider();

    const customer: CustomerItem = JSON.parse(sessionStorage.getItem(Constants.Customer) || '{}');

    this.state = {
      username: sessionStorage.getItem(Constants.Username) || '',
      sessionKey: sessionStorage.getItem(Constants.SessionKey) || '',
      isSessionValid: Boolean(sessionStorage.getItem(Constants.IsSessionValid) || ''),
      customer: customer,
      documents: [],
      alertProps: null,
    };
  }

  componentDidMount() {
    if (!this.state.isSessionValid)
      return;

    this.loadData();
    this.render();
  }

  handleError = async (title: string, error: any): Promise<void> => {
    if (error.response !== null && error.response !== undefined && error.response.status === 401) {
      sessionStorage.removeItem(Constants.IsSessionValid);
      this.setState({ isSessionValid: false });
    }
    else {
      this.setState({
        alertProps: {
          title: title,
          error: error,
          closeHandler: async () => { this.setState({ alertProps: null }); },
          show: true,
        }
      });
    }
  }

  loadData = async (): Promise<void> => {
    try {
      const documents = await this.documentProvider.getDocuments(this.state.username, this.state.sessionKey);
      documents.sort((a, b) => (a.filedate < b.filedate) ? 1 : -1)
      this.setState({ documents: documents });
    }
    catch (error) {
      this.handleError("Fehler beim Laden der Daten", error);
    }
  }

  render() {
    if (this.state.username === "" || this.state.sessionKey === "") {
      return (<Redirect to="/" />);
    }

    if (!this.state.isSessionValid) {
      return (
        <CustomAlert
          title={Constants.SessionExpiredTitle}
          error={Constants.SessionExpiredMessage}
          closeHandler={async () => {
            sessionStorage.removeItem(Constants.Username);
            sessionStorage.removeItem(Constants.SessionKey);
            this.setState({
              username: "",
              sessionKey: "",
            });
          }}
          show={true}
        />
      )
    }

    if (this.state.customer.isWebAdmin) {
      return (
        <CustomAlert
          title={Constants.AdminPageNotAvailableTitle}
          error={Constants.AdminPageNotAvailableMessage}
          show={true}
        />
      )
    }

    return (
      <div>
        <Container className="p-0">
          <CustomAlert
            {...this.state.alertProps}
          />
          <Row>
            <Col>
              <CustomerDetail customer={this.state.customer} />
            </Col>
          </Row>
          <Row>
            <Col>
              <DocumentList
                documents={this.state.documents}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
